<template>
  <div class="async-load-err">
    <Hint>
      <span>请求页面加载失败</span>
      <el-button type="text" size="mini" @click="attemptReload">重新加载</el-button>
    </Hint>
  </div>
</template>

<script>
import Hint from '../Hint'
export default {
  name: 'AsyncLoadErr',
  inject: ['$async'],
  components: {Hint},
  methods: {
    attemptReload () {
      this.$async.reload()
    }
  }
}
</script>

<style lang="scss">
  .async-load-err {
    position: relative;
    height: 100%;
    min-width: 240px;
    padding: 20px 0;
    box-sizing: border-box;
  }
</style>
